export default __webpack_public_path__ + "browserconfig.xml?f4121ddc1f32c5bfb2b012725152faa9";